import React from 'react'
import ReactDOM from 'react-dom/client'
import { Application } from './Application.tsx'

const rootElement = document.querySelector('#root')
if (!rootElement) throw new Error('Failed to find the root element')

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>
)

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // Vite에서 TypeScript Service Worker 직접 등록 (?worker 사용)
      const registration = await navigator.serviceWorker.register(
        new URL('./serviceWorker.ts?worker', import.meta.url), 
        { type: 'module' }
      )
      
      console.log('✅ ServiceWorker registration successful:', registration.scope)
    } catch (error) {
      console.log('❌ ServiceWorker registration failed:', error)
    }
  })
}